import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { DevToolSection, devHint } from '/imports/ui/DevToolSection';
import { runMtgoGoldfishJob } from '/imports/api/devtools';

export const DevToolMtgoGoldfish = () => {
  const [loading, setLoading] = useState(false);
  const [lastJobId, setLastJobId] = useState<string>('');
  const [lists, setLists] = useState<string[] | null>(null);

  const run = async () => {
    setLoading(true);
    try {
      const res = await runMtgoGoldfishJob.call();
      setLastJobId(res.jobId);
      setLists(res.lists);
      // Empty is a real outcome, not a failure: the job only touches lists that
      // are named after a metagame, so say so rather than imply work started.
      if (!res.lists.length) toast.info('No card list is named after a metagame — nothing to refresh');
      else toast.success(`Refreshing ${res.lists.length} list(s): ${res.lists.join(', ')}`);
    }
    catch (e: any) {
      toast.error(e.message || `${e}`);
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <DevToolSection
      title="Refresh MTGGoldfish Metagame Lists"
      description={
        'Manually enqueue the mtgoGoldfish job. For every Card List named after a metagame '
        + '(Standard, Modern, Pioneer, Historic, Explorer, Timeless, Alchemy, Pauper, Legacy, '
        + 'Vintage, Penny Dreadful, Premodern, Duel Commander, Commander, Brawl) it crawls that '
        + 'format on mtggoldfish.com and rewrites the list\'s <code>query</code> to the cards its '
        + 'archetypes play. Lists are never created — naming one is how you opt a format in. '
        + 'Roughly two minutes and ~120 requests per list; watch server logs for progress.'
      }
      buttonText="Enqueue Job"
      onRun={run}
      loading={loading}
    >
      {lastJobId && (
        <div className={devHint}>
          Last enqueued jobId: <code className="font-mono">{lastJobId}</code>
          {lists !== null && (
            <>
              <br />
              {lists.length
                ? <>Refreshing: <code className="font-mono">{lists.join(', ')}</code></>
                : <>No metagame-named card lists found — the job will do nothing.</>}
            </>
          )}
        </div>
      )}
    </DevToolSection>
  );
};
